import React from 'react';
import Header from '../components/Header';

function Avatar() {
  return (
    <>
      <Header />
      <h1 className="center">製作中のページです。</h1>
    </>
  );
}

export default Avatar;
